import React from 'react';

interface ActiveTrade {
  id: string;
  symbol: string;
  type: 'BUY' | 'SELL';
  entryPrice: number;
  currentPrice: number;
  amount: number;
  openTime: string;
  pnl: number;
  pnlPercentage: number;
  stopLoss: number;
  takeProfit: number;
}

interface ActiveTradesListProps {
  trades: ActiveTrade[];
}

const ActiveTradesList: React.FC<ActiveTradesListProps> = ({ trades }) => {
  
  const formatTimestamp = (timestamp: string) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
  };

  const formatCurrency = (value: number) => {
    return value.toFixed(2);
  };

  const getPnLClass = (pnl: number) => {
    if (pnl > 0) return 'text-success';
    if (pnl < 0) return 'text-danger';
    return '';
  };

  const getTypeClass = (type: string) => {
    return type === 'BUY' ? 'text-success' : 'text-danger';
  };

  if (trades.length === 0) {
    return (
      <div className="text-center p-3">
        <p className="text-muted">No hay operaciones activas</p>
      </div>
    );
  }

  return (
    <div className="active-trades-list">
      <div className="table-responsive">
        <table className="table table-sm table-hover">
          <thead>
            <tr>
              <th>Símbolo</th>
              <th>Tipo</th>
              <th>Precio</th>
              <th>Actual</th>
              <th>P&L</th>
            </tr>
          </thead>
          <tbody>
            {trades.map((trade) => (
              <tr key={trade.id}>
                <td>{trade.symbol}</td>
                <td className={getTypeClass(trade.type)}>
                  {trade.type}
                </td>
                <td>${formatCurrency(trade.entryPrice)}</td>
                <td>${formatCurrency(trade.currentPrice)}</td>
                <td className={getPnLClass(trade.pnl)}>
                  ${formatCurrency(trade.pnl)} ({trade.pnlPercentage.toFixed(2)}%)
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {trades.length > 0 && (
        <div className="mt-3">
          <h6>Detalles</h6>
          
          {trades.map((trade) => (
            <div key={trade.id} className="card mb-2">
              <div className="card-body p-3">
                <div className="d-flex justify-content-between mb-2">
                  <span className="fw-bold">
                    {trade.symbol} ({trade.type})
                  </span>
                  <span className={getPnLClass(trade.pnl)}>
                    {trade.pnl > 0 ? '+' : ''}{formatCurrency(trade.pnl)}
                  </span>
                </div>
                
                <div className="row mb-2 small">
                  <div className="col-6">
                    <span className="text-muted">Entrada:</span> ${formatCurrency(trade.entryPrice)}
                  </div>
                  <div className="col-6">
                    <span className="text-muted">Actual:</span> ${formatCurrency(trade.currentPrice)}
                  </div>
                </div>
                
                <div className="row mb-2 small">
                  <div className="col-6">
                    <span className="text-muted">Cantidad:</span> {trade.amount}
                  </div>
                  <div className="col-6">
                    <span className="text-muted">Desde:</span> {formatTimestamp(trade.openTime)}
                  </div>
                </div>
                
                <div className="row small">
                  <div className="col-6">
                    <span className="text-muted">Stop Loss:</span> ${formatCurrency(trade.stopLoss)}
                  </div>
                  <div className="col-6">
                    <span className="text-muted">Take Profit:</span> ${formatCurrency(trade.takeProfit)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActiveTradesList;
